import React from 'react';
import LazyLoad from 'react-lazyload';
import { TAG } from 'shared/constants';
import { LazyLoadImage } from 'react-lazy-load-image-component';

/**
 * @component
 * @param {Object} props - The component props
 * @param {string} props.tag - The HTML tag type to determine rendering method (e.g., TAG.IMG)
 * @param {string} props.src - The source URL of the image
 * @param {string} props.alt - Alternative text for the image (used when tag is IMG)
 * @param {string} [props.loadingmethod='lazy'] - The loading method for the image
 * @param {Object} [props.style] - Additional inline styles to apply
 * @returns {JSX.Element} Either a LazyLoadImage component or a LazyLoad wrapped div with background image
 *
 */
const LazyImage = props => {
  const { tag, src, alt, loadingmethod = 'lazy' } = props;

  return (
    <>
      {tag === TAG.IMG ? (
        <LazyLoadImage src={src} alt={alt} loading={loadingmethod} {...props} />
      ) : (
        <LazyLoad>
          <div style={{ backgroundImage: `url(${src})`, ...props?.style }} {...props} />
        </LazyLoad>
      )}
    </>
  );
};

export default LazyImage;

